import { Link } from "@inertiajs/react";
import ContentLayout from "../shared/ContentLayout";
import PageHeader from "../shared/PageHeader";
import ImageCard from "../shared/ImageCard";
import LabeledImagesSection from "../Home/sections/LabeledImagesSection";

interface LabeledImage {
  id: number;
  title: string;
  description: string;
  image_url: string;
  labels: {
    text: string;
    coordinates: { x: number; y: number }[];
  }[];
}

export default function IconsIndex({ icons }: { icons: LabeledImage[] }) {
  const renderBreadcrumbs = () => (
    <div className="breadcrumbs text-sm">
      <ul>
        <li>
          <Link href="/" className="link link-primary">
            Home
          </Link>
        </li>
        <li>
          <span>Icons</span>
        </li>
      </ul>
    </div>
  );

  return (
    <ContentLayout breadcrumbs={renderBreadcrumbs()}>
      <div className="p-3 sm:p-4 max-w-4xl">
        <PageHeader title="Icônes" />
        <div className="flex flex-col gap-4">
          <LabeledImagesSection
            labeledImages={icons}
          />
        </div>
      </div>
    </ContentLayout>
  )
}
